export type TargetAudience = 'B2B' | 'B2C' | 'Both' | null;

export interface Filters {
  searchQuery: string;
  mrrRange: [number, number];
  growthRange: [number, number];
  customersRange: [number, number];
  categories: Set<string>;
  subcategories: Set<string>;
  clusters: Set<string>;
  countries: Set<string>;
  targetAudience: TargetAudience;
  onSale: boolean | null;
}

export const DEFAULT_FILTERS: Filters = {
  searchQuery: '',
  mrrRange: [0, Infinity],
  growthRange: [-Infinity, Infinity],
  customersRange: [0, Infinity],
  categories: new Set(),
  subcategories: new Set(),
  clusters: new Set(),
  countries: new Set(),
  targetAudience: null,
  onSale: null,
};
